<div class="pages-sidebar" [class.collapsed]="isCollapsed()">
  <div class="tools-section">
    <div class="header">
      <span class="title">{{ title }}</span>
      <sui-button
        variant="ghost"
        [leadingIcon]="getToggleIcon(isCollapsed())"
        [iconOnly]="true"
        ariaLabel="Toggle pages sidebar"
        (click)="toggleCollapse()"
      ></sui-button>
    </div>

    <div class="collapsible-content">
      <app-search-input (inputChanged)="onSearchFilterChange($event)">
      </app-search-input>

      <div class="divider"></div>

      <div class="dropdown-component">
        <sui-button
          variant="ghost"
          [leadingIcon]="faBars"
          [trailingIcon]="['fas', 'caret-down']"
          [expanded]="pageActionsDropdownRef.isOpen()"
          [disabled]="(selectedDashboardPageIds$ | async)?.length === 0"
          [suiTooltip]="'page-navigator.actions-menu.tooltip' | translate"
          #pageActionsTooltipRef="suiTooltip"
          [suiMenuTrigger]="pageActionsMenu"
          suiMenuPlacement="right-start"
          #pageActionsDropdownRef="suiMenu"
          (openChange)="$event && pageActionsTooltipRef.close()"
        >
          {{ "page-navigator.actions-menu.text" | translate }}
        </sui-button>

        <ng-template #pageActionsMenu>
          <sui-menu>
            <button sui-menu-item (click)="includeInPresentation($event)">
              <fa-icon [icon]="faPlus"></fa-icon>
              <span>{{
                "page-navigator.actions-menu.include-in-presentation"
                  | translate
              }}</span>
            </button>

            <sui-menu-separator></sui-menu-separator>

            <button sui-menu-item (click)="excludeFromPresentation($event)">
              <fa-icon [icon]="faMinus"></fa-icon>
              <span>{{
                "page-navigator.actions-menu.exclude-from-presentation"
                  | translate
              }}</span>
            </button>

            <sui-menu-separator></sui-menu-separator>

            <button
              sui-menu-item
              [disabled]="allPagesSelected(selectedDashboardPageIds$ | async)"
              (click)="deleteSelectedPages($event)"
            >
              <fa-icon [icon]="faTrash"></fa-icon>
              <span>{{
                "page-navigator.actions-menu.delete-selected-pages" | translate
              }}</span>
            </button>
          </sui-menu>
        </ng-template>
      </div>

      <div class="divider"></div>
    </div>
  </div>

  <div
    class="list"
    cdkDropList
    [cdkDropListDisabled]="hasActiveSearch"
    (cdkDropListDropped)="onDrop($event)"
    [class.reordering]="isReordering"
  >
    @for (page of filteredPages; track page) {
      <div
        cdkDrag
        [cdkDragDisabled]="hasActiveSearch"
        class="list-item"
        [class.selected]="page.id === selectedPageId"
        [class.multi-selected]="
          isPageMultiSelected(page, selectedDashboardPageIds$ | async)
        "
        [class.reordering]="isReordering"
        [style.opacity]="isPageVisible(page) ? 1 : 0.5"
        (click)="onPageClick(page.id, $event)"
      >
        <div class="page-index">{{ page.page_order }}.</div>
        <div class="page-tile">
          <div class="page-tools">
            <fa-icon
              class="play-icon clickable"
              [icon]="isPageVisible(page) ? faCirclePlay : faCircleStop"
              [ngClass]="{
                'in-range': isPageVisible(page),
                'out-of-range': !isPageVisible(page),
              }"
              [suiTooltip]="
                isPageVisible(page)
                  ? ('page-navigator.tooltip.included-in-presentation-range'
                    | translate)
                  : ('page-navigator.tooltip.not-in-presentation-range'
                    | translate)
              "
              (click)="onVisibilityIconClick(page, $event)"
            ></fa-icon>
            <app-date-range-picker-dashboard-page
              [pageId]="page.id"
            ></app-date-range-picker-dashboard-page>
            <div class="card-tool" (click)="$event.stopPropagation()">
              <sui-button
                size="sm"
                variant="ghost"
                [leadingIcon]="faBars"
                [iconOnly]="true"
                ariaLabel="Page actions"
                [expanded]="pageRowDropdownRef.isOpen()"
                [disabled]="pages.length <= 1"
                [suiMenuTrigger]="pageRowMenu"
                #pageRowDropdownRef="suiMenu"
              ></sui-button>
              <ng-template #pageRowMenu>
                <sui-menu>
                  <button
                    sui-menu-item
                    [disabled]="pages.length <= 1"
                    (click)="onDeletePageClick(page.id, $event)"
                  >
                    <fa-icon [icon]="faTrash"></fa-icon>
                    <span>{{
                      "page-navigator.button.delete" | translate
                    }}</span>
                  </button>
                </sui-menu>
              </ng-template>
            </div>
          </div>
          @if (
            presentationSettings?.mode === "auto" &&
            presentationSettings?.show_timer
          ) {
            <div class="page-timeout">
              <fa-icon [icon]="faClock"></fa-icon>
              <span class="timeout-value">{{ page.duration_seconds }}s</span>
            </div>
          }
          <div class="page-details">
            <span class="name">{{ page.name }}</span>
            <span class="description">{{ page.description }}</span>
          </div>
        </div>
        <!-- drag Preview template -->
        <div *cdkDragPreview class="drag-preview">
          <div class="page-index">{{ page.page_order }}.</div>
          <div class="page-tile-preview">
            <div class="page-details">
              <span class="name">Moving {{ page.name }}...</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="create-page" (click)="createPage()">
    <div class="circle-plus">
      <fa-icon [icon]="faPlus"></fa-icon>
    </div>
  </div>
</div>
